// client/src/pages/Rules.js
export default function Rules() {
  return (
    <div className="min-h-screen bg-cream dark:bg-bg-dark transition-colors duration-300">
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <h1 className="font-display text-3xl sm:text-4xl text-gold-dark dark:text-gold mb-2">Official Rules</h1>
        <p className="text-royal-500 dark:text-royal-200 text-base mb-2">
          The Cherry Fairy Shop Free One-Year Subscription Sweepstakes
        </p>
        <p className="text-royal-500 dark:text-royal-200 text-base mb-8">Last updated: July 23, 2026</p>

        <div className="space-y-8 text-royal-700 dark:text-royal-100 text-base leading-relaxed">

          <section>
            <p className="text-royal-900 dark:text-white font-medium uppercase text-sm tracking-wide leading-relaxed">
              No purchase or payment of any kind is necessary to enter or win. A purchase will not increase
              your chances of winning. Void where prohibited or restricted by law.
            </p>
            <p className="mt-3">
              By entering, you agree to be bound by these Official Rules and by the decisions of the Sponsor,
              which are final and binding in all respects.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">1. Sponsor</h2>
            <p>
              This Sweepstakes is sponsored by Todd Davis, owner of The Cherry Fairy Shop, 875 N 140 W,
              American Fork, Utah 84003 (the "Sponsor"). Questions may be directed to{' '}
              <a
                href="mailto:thecherryfairies@gmail.com"
                className="text-gold-dark dark:text-gold hover:text-gold dark:hover:text-gold-light transition-colors"
              >
                thecherryfairies@gmail.com
              </a>.
            </p>
            <p className="mt-3">
              References in these Official Rules to "The Cherry Fairy Shop" mean the website and services
              operated by the Sponsor at https://thecherryfairyshop.com.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">2. Eligibility</h2>
            <p>
              The Sweepstakes is open only to legal residents of the fifty (50) United States and the District
              of Columbia who are eighteen (18) years of age or older at the time of entry.
            </p>
            <p className="mt-3">The following persons are not eligible to enter or win:</p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                Any individual who held an account of any type with The Cherry Fairy Shop — whether free, paid,
                complimentary, or otherwise — as of the start of the Entry Period;
              </li>
              <li>The Sponsor, and any employees, contractors, and agents of the Sponsor; and</li>
              <li>
                The immediate family members (spouse, parent, child, sibling, and their respective spouses,
                regardless of where they reside) and members of the same household (whether related or not)
                of any person listed above.
              </li>
            </ul>
            <p className="mt-3">
              This Sweepstakes is open only to individuals who are new to The Cherry Fairy Shop. If you already
              have an account with The Cherry Fairy Shop, you are not eligible, and creating an additional or
              duplicate account will not make you eligible.
            </p>
            <p className="mt-3">
              The Sweepstakes is void outside the United States and wherever else prohibited or restricted by law.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">3. Entry Period</h2>
            <p>
              The Sweepstakes begins on Saturday, July 25, 2026 at 6:00:00 a.m. Mountain Time and ends on
              Saturday, July 25, 2026 at 11:59:59 p.m. Mountain Time (the "Entry Period").
            </p>
            <p className="mt-3">
              Entries submitted before or after the Entry Period will not be eligible. Sponsor's computer is
              the official time-keeping device for this Sweepstakes.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">4. How to Enter</h2>
            <p>
              To enter, visit https://thecherryfairyshop.com during the Entry Period and create a free account.
              Account creation is free and requires no purchase or payment of any kind. You must provide a valid
              email address that you own and control, and you must complete all required registration fields.
              Completion of the free account registration constitutes your entry.
            </p>
            <p className="mt-3">
              Limit one (1) entry per person and per email address for the duration of the Entry Period. Creating
              or attempting to create multiple accounts, using multiple email addresses, or using any automated
              system, script, bot, or other device to enter will void all of that entrant's entries and may
              result in disqualification.
            </p>
            <p className="mt-3">
              Entries that are incomplete, illegible, inaccurate, or that do not comply with these Official Rules
              are void. Sponsor is not responsible for entries that are lost, late, misdirected, garbled, or not
              received for any reason, including technical failures of any kind.
            </p>
            <p className="mt-3">
              All entries become the property of Sponsor and will not be acknowledged or returned. Information
              collected through entry is subject to Sponsor's Privacy Policy, available at{' '}
              <a
                href="/privacy"
                className="text-gold-dark dark:text-gold hover:text-gold dark:hover:text-gold-light transition-colors"
              >
                https://thecherryfairyshop.com/privacy
              </a>
              , and to Section 11 below.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">5. Prize</h2>
            <p>
              One (1) Grand Prize will be awarded: a one (1) year subscription to The Cherry Fairy Shop at the
              Fairydust level.
            </p>
            <p className="mt-3">Approximate Retail Value ("ARV"): $76.00 USD.</p>
            <p className="mt-3">
              The prize will be delivered to the winner by email in the form of a one-time-use gift code, which
              the winner must redeem in their Cherry Fairy Shop account. The gift code must be redeemed within
              thirty (30) days of issuance or it will expire and the prize will be forfeited.
            </p>
            <p className="mt-3">
              Once redeemed, the subscription begins on the date of redemption and continues for twelve (12)
              consecutive months. At the end of the twelve-month period, the winner's account will automatically
              revert to a free account. No payment method is required, no charge will be made, and the
              subscription will not automatically renew. The winner may purchase a subscription at then-current
              rates at any time thereafter.
            </p>
            <p className="mt-3">Total ARV of all prizes: $76.00 USD.</p>
            <p className="mt-3">
              Odds of winning depend on the total number of eligible entries received during the Entry Period.
            </p>
            <p className="mt-3">
              The prize is non-transferable, and no substitution, assignment, or cash equivalent is permitted,
              except that Sponsor reserves the right to substitute a prize of equal or greater value if the
              advertised prize becomes unavailable for any reason. All costs and expenses not expressly stated
              as included in the prize are the sole responsibility of the winner. All federal, state, and local
              taxes on the prize, if any, are the sole responsibility of the winner.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">6. Winner Selection</h2>
            <p>
              The winner will be selected in a random drawing from among all eligible entries received during
              the Entry Period. The drawing will be conducted on or about Monday, July 27, 2026 by Sponsor or
              its designated representative, whose decisions are final and binding in all matters relating to
              this Sweepstakes.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">
              7. Winner Notification and Claim Deadline
            </h2>
            <p>
              The potential winner will be notified by email sent to the email address associated with the
              account used to enter, sent on or about Monday, July 27, 2026.
            </p>
            <p className="mt-3">
              The potential winner must respond to the notification email within forty-eight (48) hours of the
              time it is sent and must confirm eligibility and acceptance of the prize as instructed in that email.
            </p>
            <p className="mt-3">
              If the potential winner: (a) does not respond within the 48-hour period; (b) cannot be contacted,
              or the notification is returned as undeliverable; (c) declines the prize; (d) is found to be
              ineligible; or (e) fails to comply with these Official Rules in any respect, then that potential
              winner will forfeit the prize and Sponsor may, at its sole discretion, select an alternate winner
              in a subsequent random drawing from among the remaining eligible entries. Sponsor is not obligated
              to conduct more than two (2) alternate drawings, after which the prize may go unawarded.
            </p>
            <p className="mt-3">
              Sponsor may require the potential winner to sign and return an Affidavit of Eligibility, a
              Liability Release, and, where lawful, a Publicity Release before the prize is awarded.
            </p>
            <p className="mt-3">
              It is each entrant's responsibility to ensure that the email address on their account is accurate
              and current, and to check their email — including spam, promotions, and junk folders — during the
              notification window.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">8. Publicity</h2>
            <p>
              Except where prohibited by law, acceptance of the prize constitutes the winner's consent for
              Sponsor to use the winner's first name, last initial, and state of residence for promotional
              purposes in any media, worldwide, without further payment, notice, or consideration.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">9. General Conditions</h2>
            <p>
              Sponsor reserves the right, in its sole discretion, to disqualify any individual it finds to be:
              tampering with the entry process or the operation of the Sweepstakes or the Sponsor's website;
              acting in violation of these Official Rules; or acting in a manner that is unsportsmanlike,
              disruptive, or with the intent to annoy, abuse, threaten, or harass any other person.
            </p>
            <p className="mt-3">
              Sponsor reserves the right, in its sole discretion, to cancel, terminate, modify, or suspend the
              Sweepstakes, in whole or in part, should any virus, bug, non-authorized human intervention, fraud,
              technical failure, or any other cause beyond Sponsor's reasonable control corrupt or affect the
              administration, security, fairness, or proper conduct of the Sweepstakes. In such an event,
              Sponsor may, at its discretion, award the prize in a random drawing from among all eligible,
              non-suspect entries received prior to the action taken.
            </p>
            <p className="mt-3">
              Sponsor's failure to enforce any term of these Official Rules does not constitute a waiver of that term.
            </p>
            <p className="mt-3 text-royal-900 dark:text-white font-medium uppercase text-sm tracking-wide leading-relaxed">
              Caution: Any attempt by any person to deliberately damage the Sponsor's website or undermine the
              legitimate operation of the Sweepstakes may be a violation of criminal and civil law, and should
              such an attempt be made, the Sponsor reserves the right to seek damages from any such person to
              the fullest extent permitted by law.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">
              10. Release and Limitation of Liability
            </h2>
            <p>
              By entering, each entrant agrees to release, discharge, indemnify, and hold harmless the Sponsor,
              Todd Davis individually and as owner of The Cherry Fairy Shop, and the Sponsor's employees,
              contractors, agents, successors, and assigns (collectively, the "Released Parties") from and
              against any and all claims, damages, losses, liability, injury, or expense of any kind arising
              out of or relating to participation in this Sweepstakes or the acceptance, receipt, possession,
              use, or misuse of the prize.
            </p>
            <p className="mt-3">
              The Released Parties are not responsible for: any incorrect or inaccurate information, whether
              caused by entrants, printing errors, or by any equipment or programming associated with the
              Sweepstakes; technical failures of any kind, including malfunctions, interruptions, or
              disconnections in phone lines or network hardware or software; unauthorized human intervention
              in any part of the entry process or the Sweepstakes; technical or human error in the
              administration of the Sweepstakes or the processing of entries; or any injury or damage to
              persons or property that may be caused, directly or indirectly, in whole or in part, from an
              entrant's participation in the Sweepstakes or receipt or use of the prize.
            </p>
            <p className="mt-3">
              If, for any reason, an entry is confirmed to have been erroneously deleted, lost, or otherwise
              destroyed or corrupted, the entrant's sole remedy is another entry in the Sweepstakes, if it is
              possible to award one.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">11. Privacy</h2>
            <p>
              Information submitted in connection with this Sweepstakes will be collected and used by Sponsor
              in accordance with Sponsor's Privacy Policy, available at{' '}
              <a
                href="/privacy"
                className="text-gold-dark dark:text-gold hover:text-gold dark:hover:text-gold-light transition-colors"
              >
                https://thecherryfairyshop.com/privacy
              </a>
              . By creating an account, you acknowledge that Sponsor may send you emails related to your account
              and to this Sweepstakes, as well as periodic product updates and promotional offers. You may
              unsubscribe from promotional emails at any time using the unsubscribe link included in every such
              message.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">
              12. Disputes and Governing Law
            </h2>
            <p>
              Except where prohibited by law, each entrant agrees that: (a) any and all disputes, claims, and
              causes of action arising out of or connected with this Sweepstakes, or any prize awarded, shall be
              resolved individually, without resort to any form of class action; (b) any and all claims,
              judgments, and awards shall be limited to actual out-of-pocket costs incurred, including costs
              associated with entering this Sweepstakes, but in no event attorneys' fees; and (c) under no
              circumstances will any entrant be permitted to obtain awards for, and each entrant hereby waives
              all rights to claim, punitive, incidental, and consequential damages and any other damages, other
              than for actual out-of-pocket expenses, and any and all rights to have damages multiplied or
              otherwise increased.
            </p>
            <p className="mt-3">
              All issues and questions concerning the construction, validity, interpretation, and enforceability
              of these Official Rules, or the rights and obligations of entrants and Sponsor in connection with
              this Sweepstakes, shall be governed by and construed in accordance with the laws of the State of
              Utah, without regard to its conflict of law rules. Any legal proceedings shall take place in the
              state or federal courts located in Salt Lake County, Utah, and all entrants consent to the
              jurisdiction and venue of such courts.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">13. Winner Announcement</h2>
            <p>
              All entrants will be notified of the outcome of the Sweepstakes by email sent to the address
              associated with their entry, on or about Wednesday, July 29, 2026. That announcement will identify
              the winner by first name, last initial, and state of residence only. The winner's name will not be
              posted on the website.
            </p>
            <p className="mt-3">
              Entrants who do not receive the announcement email may also request the winner's name by sending a
              self-addressed stamped envelope to Todd Davis, The Cherry Fairy Shop, Attn: Sweepstakes Winner
              List, 875 N 140 W, American Fork, Utah 84003, to be received no later than October 27, 2026.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-royal-900 dark:text-white mb-3">Questions</h2>
            <p>If you have any questions about these Official Rules, contact us at:</p>
            <p className="mt-2">
              <span className="text-royal-900 dark:text-white font-medium">The Cherry Fairy Shop</span><br />
              Todd Davis<br />
              875 N 140 W<br />
              American Fork, Utah 84003<br />
              <a
                href="mailto:thecherryfairies@gmail.com"
                className="text-gold-dark dark:text-gold hover:text-gold dark:hover:text-gold-light transition-colors"
              >
                thecherryfairies@gmail.com
              </a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}